import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import Tabs from "../../CommonComponents/Tabs";
import Table from "./Table";
import Pagination from "./Pagination";
import { formatAmount } from "../../../../../Util";

const MainContent = ({ userType: propUserType }) => {
  const { userType: paramUserType } = useParams();
  const location = useLocation();
  const userType = propUserType || paramUserType;
  const isMonazam = userType === "monazam";

  const [amount, setAmount] = useState(0);

  return (
    <div className="container-fluid main-content-table bgColor d-flex flex-column overflow-hidden mt-2">
      <hr />
      

      <div className="flex-grow-1 d-flex flex-column pt-2">
        <div className="row mb-4 align-items-start mx-0">
          <div className="col-md-12 d-flex justify-content-end align-items-center mt-3 mt-md-0">
            <div className="balance-box p-2 border-2">
              <div>
                <div className="balance-txt">Balance</div>
                <div className="amount-text fw-bold text-success">{`SAR ${amount.toLocaleString()}`}</div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="table-wrapper marginRight flex-grow-1 p-3 rounded shadow-sm d-flex flex-column"
        >
          <div className="table-container scroll flex-grow-1">
              <Table
                setAmount={setAmount}
                isMonazam={isMonazam}
              />
          </div>

          <div className="d-flex justify-content-end align-items-center mt-auto">
            <Pagination />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainContent;